import { render, staticRenderFns } from "./postAdmin.vue?vue&type=template&id=50f402ae&scoped=true"
import script from "./postAdmin.vue?vue&type=script&lang=js"
export * from "./postAdmin.vue?vue&type=script&lang=js"
import style0 from "./postAdmin.vue?vue&type=style&index=0&id=50f402ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f402ae",
  null
  
)

export default component.exports